import React, { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
const OTPBox = ({pin1,pin2,pin3,pin4,pin5,pin6,setPin1,setPin2,setPin3,setPin4,setPin5,setPin6}) => {
  const pin1Ref = useRef(null);
  const pin2Ref = useRef(null);
  const pin3Ref = useRef(null);
  const pin4Ref = useRef(null);
  const pin5Ref = useRef(null);
  const pin6Ref = useRef(null); 
  useEffect(()=>{
    pin1Ref.current.focus();
   },[])
   const handleKeyDown = (e, setPin, prevRef, nextRef) => {
    if (e.key === 'Backspace' && !e.target.value) {
      if (prevRef) {
        prevRef.current.focus();
      }
    } else if (e.key !== 'Backspace' && e.target.value) {
      if (nextRef) {
        nextRef.current.focus();
      }
    }
  };
  const handleChange = (e, setPin, nextRef) => {
    const value = e.target.value.replace(/\D/, '');
    setPin(value);
    if (value && nextRef) {
      nextRef.current.focus();
    }
  };
  return (
    <>
        
            <Form>
                <Form.Group>
                    <Form.Label>OTP <span className='redStar'>*</span></Form.Label>
                    <div className='fourBox'>
                         <Form.Control 
                            ref= {pin1Ref}
                            type= 'text'
                            maxLength={1}
                            pattern="[0-9]*"
                            value={pin1}
                            onKeyDown={(e) => handleKeyDown(e, setPin1, null, pin2Ref)}
                            onChange={(e) => handleChange(e, setPin1, pin2Ref)}

                          />
                         <Form.Control 
                            ref= {pin2Ref}
                            type= 'text'
                            maxLength={1}
                            pattern="[0-9]*"
                            value={pin2}
                            onKeyDown={(e) => handleKeyDown(e, setPin2, pin1Ref, pin3Ref)}
                            onChange={(e) => handleChange(e, setPin2, pin3Ref)}

                          />
                          <Form.Control 
                            ref= {pin3Ref}
                            type= 'text'
                            maxLength={1}
                            pattern="[0-9]*"
                            value={pin3}
                            onKeyDown={(e) => handleKeyDown(e, setPin3, pin2Ref, pin4Ref)}
                            onChange={(e) => handleChange(e, setPin3, pin4Ref)}

                          />
                          <Form.Control 
                            ref= {pin4Ref}
                            type= 'text'
                            maxLength={1}
                            pattern="[0-9]*"
                            value={pin4}
                            onKeyDown={(e) => handleKeyDown(e, setPin4, pin3Ref, pin5Ref)}
                            onChange={(e) => handleChange(e, setPin4, pin5Ref)}
                          />
                          <Form.Control 
                            ref= {pin5Ref}
                            type= 'text'
                            maxLength={1}
                            pattern="[0-9]*"
                            value={pin5}
                            onKeyDown={(e) => handleKeyDown(e, setPin5, pin4Ref, pin6Ref)}
                            onChange={(e) => handleChange(e, setPin5, pin6Ref)}

                          />
                          <Form.Control 
                            ref= {pin6Ref}
                            value={pin6}
                            type='text'
                            maxLength={1}
                            pattern="[0-9]*"
                            onKeyDown={(e) => handleKeyDown(e, setPin6, pin5Ref, null)}
                            onChange={(e) => handleChange(e, setPin6, null)}
                           />
                         
                    </div>
                    
                </Form.Group>
            </Form>

            
           
  
    </>
  )
}

export default OTPBox